import request from '@/libs/request'

// 基地管理员 列表
export function landBaseAdminListApi (data) {
  return request({
    url: `landBase/landBaseAdmin`,
    method: 'get',
    params: data
  })
}

// 基地管理员 详情
export function landBaseAdminInfoApi (id) {
  return request({
    url: `landBase/landBaseAdmin/` + id,
    method: 'get'
  })
}


// 基地管理员 编辑/添加
export function landBaseAdminSaveApi (data) {
  return request({
    url: `landBase/landBaseAdmin`,
    method: 'post',
    data: data
  })
}

// 基地管理员 删除
export function landBaseAdminDelApi (id) {
  return request({
    url: `landBase/landBaseAdmin/` + id,
    method: 'delete',
  })
}



